export default __webpack_public_path__ + "static/media/people.be895217.png";